import {Injectable} from "@angular/core";
import {RestApiCall} from "../core/services/rest-api/restApi.service";
import {AuthService} from "../core/authentication/auth.service";
import {Observable, Subscription} from "rxjs";
import {Range} from "./../model/range";
import {Response} from "../model/response";
import {Urls} from "../../environments/environment";
import {endPoints} from "./APIUtils";
import {cloneRangeObject} from "../core/utils";

@Injectable()
export class AlertsService {
  alerts: Array<string>;

  constructor(private restApiCall: RestApiCall, private authService: AuthService) {
  }

  getAlertsStats(range: Range): Observable<Response> {
    let url = `${Urls.base_url}alerts/${this.authService.agency.CITY ? this.authService.agency.CITY.toLowerCase() : ''}/overview`;
    let {startDate, endDate} = this.getUpdatedRange(range);
    let params = this.restApiCall.getURLSearchParams()
      .set("from", startDate.getTime().toString())
      .set("to", endDate.getTime().toString())
      .set("uid", this.authService.agency.UID);
    if (this.authService.agency.NAME) params = params.set('agency', this.authService.agency.NAME.toUpperCase());
    if (this.authService.agency.OPERATOR) params = params.set('operator', this.authService.agency.OPERATOR);
    return this.restApiCall.get(url, params);
  }


  private getUpdatedRange(r: Range) {
    let range = cloneRangeObject(r);
    if (range && range.startDate.getDate() == range.endDate.getDate() && range.startDate.getDate() != new Date().getDate()) {
      range.startDate.setHours(0, 0, 0, 0);
      range.endDate.setHours(23, 59, 59, 0);
    }
    return range;
  }

  getRecentAlertsCount(range: Range, type, filter?: string): Observable<Response> {
    let url = `${Urls.base_url}${this.authService.agency.CITY ? this.authService.agency.CITY.toLowerCase() : ''}/alertCount`;
    let {startDate, endDate} = this.getUpdatedRange(range);
    let params = this.restApiCall.getURLSearchParams()
      .set("from", startDate.getTime().toString())
      .set("to", endDate.getTime().toString())
      .set("type", type.toString())
      .set("uid", this.authService.agency.UID);
    if (this.authService.agency.NAME) params = params.set('agency', this.authService.agency.NAME.toUpperCase());
    if (this.authService.agency.OPERATOR) params = params.set('operator', this.authService.agency.OPERATOR);
    if (filter && filter.length > 0) params = params.set("filter", filter);
    return this.restApiCall.get(url, params);
  }

  getRecentAlerts(range: Range, type, rangeStart, rangeEnd, routeId, vehicleId): Observable<Response> {
    let url = `${Urls.base_url}alerts/${this.authService.agency.CITY ? this.authService.agency.CITY.toLowerCase() : ''}/recentAlerts/${type}`;
    let {startDate, endDate} = this.getUpdatedRange(range);
    let params = this.restApiCall.getURLSearchParams()
      .set("from", startDate.getTime().toString())
      .set("to", endDate.getTime().toString())
      .set("rangeStart", (rangeStart).toString())
      .set("rangeEnd", (rangeEnd).toString())
      .set("uid", this.authService.agency.UID);
    if (this.authService.agency.NAME) params = params.set('agency', this.authService.agency.NAME.toUpperCase());
    if (this.authService.agency.OPERATOR) params = params.set('operator', this.authService.agency.OPERATOR);
    if (routeId) {
      url = Urls.base_url + (this.authService.agency.CITY ? this.authService.agency.CITY.toLowerCase() : '') + '/' + (this.authService.agency.NAME ? this.authService.agency.NAME.toUpperCase() : '') + '/routeStat/recentAlerts/' + type;
      params = params.set("routeId", routeId)
    }
    if (vehicleId) {
      url = Urls.base_url + (this.authService.agency.CITY ? this.authService.agency.CITY.toLowerCase() : '') + '/' + (this.authService.agency.NAME ? this.authService.agency.NAME.toUpperCase() : '') + '/vehicleStat/recentAlerts/' + type;
      params = params.set("vehicleId", vehicleId);
    }
    return this.restApiCall.get(url, params);
  }

  getAllAlerts(range: Range, type, rangeStart, rangeEnd, filter?: string, exportAll?: boolean): Observable<Response> {
    let url = `${Urls.base_url}${this.authService.agency.CITY.toLowerCase()}${endPoints.ALERTS}`;
    let params = this.restApiCall.getURLSearchParams()
      .set("from", range.startDate.getTime().toString())
      .set("to", range.endDate.getTime().toString())
      .set("rangeStart", (rangeStart).toString())
      .set("rangeEnd", (rangeEnd).toString())
      .set("type", type.toString())
      .set("uid", this.authService.agency.UID);
    if (this.authService.agency.NAME) params = params.set('agency', this.authService.agency.NAME.toUpperCase());
    if (this.authService.agency.OPERATOR) params = params.set('operator', this.authService.agency.OPERATOR);
    filter && filter.length > 0 && (params = params.set("filter", filter));
    exportAll && (params = params.set('exportall', exportAll.toString()));
    return this.restApiCall.get(url, params);
  }

  getAlertDetail(id: string): Observable<Response> {
    let url = `${Urls.base_url}alert/${this.authService.agency.CITY.toLowerCase()}${endPoints.ALERTS_DETAIL}`;
    let params = this.restApiCall.getURLSearchParams()
      .set("alertId", id)
      .set("operator", this.authService.agency.OPERATOR)
      .set("uid", this.authService.agency.UID);
    if (this.authService.agency.NAME) params = params.set('agency', this.authService.agency.NAME.toUpperCase());
    if (this.authService.agency.OPERATOR) params = params.set('operator', this.authService.agency.OPERATOR);
    return this.restApiCall.get(url, params);
  }

  download() {
    let url = '\n' +
      'https://devapihomedecor.cloudzmall.com/api/invoice/download?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGVObyI6Iis5MTk2NDM4MjkxMTAiLCJpZCI6IjI1MCIsInJvbGUiOiJzZXJ2aWNlUHJvdmlkZXIiLCJlbWFpbCI6ImdhdXJhdi5rb2NoYXIrNkBkYWZmb2RpbHN3LmNvbSIsImlhdCI6MTU2MDIzNzU2OSwiZXhwIjoxNTYwMjgwNzY5fQ.tS5IJyMHYhddk58DBO1rnrv5diDPuxgV8KRokilE6gY&location=https://homedecorating.s3.amazonaws.com/invoice/pdf/hwNMAln28a-1560237567492-invoice.pdf';
    return this.restApiCall.downLoad(url);
  }
}
